import * as React from "react";

const OrangeSvg = (props) => (
  <svg width={102} height={186} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.686 4.686C0 9.373 0 16.916 0 32v122c0 15.085 0 22.627 4.686 27.314C9.373 186 16.916 186 32 186h53c9.204 0 16.666-9.914 16.666-22.143 0-5.391-1.45-10.331-3.86-14.171 2.41-3.84 3.86-8.781 3.86-14.172s-1.45-10.331-3.86-14.171c2.41-3.84 3.86-8.781 3.86-14.172 0-5.39-1.45-10.331-3.86-14.171 2.41-3.84 3.86-8.781 3.86-14.172 0-5.39-1.449-10.331-3.86-14.17 2.411-3.84 3.86-8.782 3.86-14.172 0-5.39-1.45-10.331-3.86-14.172 2.41-3.84 3.86-8.78 3.86-14.171C101.666 9.913 94.205 0 85 0H32C16.915 0 9.373 0 4.686 4.686Z"
      fill={props.color}
    />
  </svg>
);

export default OrangeSvg;
